/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from "react"
import "./src/global.css"

const HOME_PATHS = new Set(["/", "/index.html"])

export const onClientEntry = () => {
  if (typeof document === "undefined") return
  document.documentElement.classList.add("is-ready")
}

/** Motion Language — page.enter / page.instant */
export const wrapPageElement = ({ element, props }) => {
  const isHome = HOME_PATHS.has(props.location.pathname)

  return (
    <div key={props.location.pathname} className={isHome ? "ml-page-instant" : "ml-page-enter"}>
      {element}
    </div>
  )
}
